import { AutenticacionService } from './../../services/autenticacion.service';
import { PrintReciboModalComponent } from './../partials/print-recibo-modal/print-recibo-modal.component';
import { PrintChequeModalComponent } from './../partials/print-cheque-modal/print-cheque-modal.component';
import { SecurityModalComponent } from './../partials/security-modal/security-modal.component';
import { ValidatorService } from '../../services/tools/validator.service';
import { Component, OnInit, ViewChild } from '@angular/core';
import { SuccessModalComponent } from '../tools/modals/success-modal/success-modal.component';
import { ErrorModalComponent } from '../tools/modals/error-modal/error-modal.component';
import { ConfirmModalComponent } from '../tools/modals/confirm-modal/confirm-modal.component';
import { MovimientosObraService } from '../../services/movimientos-obra.service';
import { ObrasService } from "../../services/obras.service";
import { CuentasService } from "../../services/cuentas.service";
import { ConceptosService } from "../../services/conceptos.service";
import { ProveedoresService } from "../../services/proveedores.service";
import { HelpersService } from "../../services/tools/helpers.service";
import { CatalogosSatService } from '../../services/catalogos-sat-service';
import { WarningModalComponent } from "../tools/modals/warning-modal/warning-modal.component";
import { Globals } from './../../services/tools/Globals.service';
import { MovimientosModalComponent } from './movimientos-modal/movimientos-modal.component';
import { ModalSeleccionCXCComponent } from './modal-seleccion-cxc/modal-seleccion-cxc.component';
import { ModalSeleccionCXPComponent } from './modal-seleccion-cxp/modal-seleccion-cxp.component';
import { ModalIngresoInterno } from './modal-ingreso-interno/modal-ingreso-interno.component';
import { ModalNuevoMovCarpetaBlancaComponent } from './modal-nuevo-mov-carpeta-blanca/modal-nuevo-mov-carpeta-blanca.component';



declare var $;
declare var moment;

@Component({
  selector: 'app-movimientos-obra',
  templateUrl: './movimientos-obra.component.html',
  styleUrls: ['./movimientos-obra.component.scss']
})
export class MovimientosObraComponent implements OnInit {
  @ViewChild(SuccessModalComponent) successModal: SuccessModalComponent;
  @ViewChild(ErrorModalComponent) errorModal: ErrorModalComponent;
  @ViewChild(ConfirmModalComponent) confirmModal: ConfirmModalComponent;
  @ViewChild(WarningModalComponent) warningModal: WarningModalComponent;
  @ViewChild(SecurityModalComponent) securityModal: SecurityModalComponent;
  @ViewChild(PrintReciboModalComponent) printReciboModal: PrintReciboModalComponent;
  @ViewChild(PrintChequeModalComponent) printChequeModal: PrintChequeModalComponent;
  @ViewChild(MovimientosModalComponent) movimientosModal: MovimientosModalComponent;
  @ViewChild(ModalSeleccionCXCComponent) modalSeleccionarCXC: ModalSeleccionCXCComponent;
  @ViewChild(ModalSeleccionCXPComponent) modalSeleccionCXP: ModalSeleccionCXPComponent;
  @ViewChild(ModalIngresoInterno) modalIngresoInterno: ModalIngresoInterno;
  @ViewChild('modalNuevoMovCB') modalNuevoMovCB: ModalNuevoMovCarpetaBlancaComponent;




  movimientosObra: any[];
  totales: any;
  searchText: string = "";
  mostrarListado: boolean = true;
  errors: any = {};
  searchProcess: any;
  paginate: any = {};
  fechaActual: string;
  currentPage: any = 1;
  lastPage: any = 1;
  processing: any = false;
  alterTable: any = 'starting';
  securityActived: any = false;
  exportingCSV: any = false;
  agregarconceptos: any = false;
  importeCuentaSeleccionada: any = null;
  //Facturas que cubre un mismo deposito: van en un solo complemento de pago
  public cuentasPorCobrarSeleccionadas: any[] = [];
  public avisoAgrupado: string = null;
  /* selected */
  movimientosObraSelected: any = null;
  conceptosSelectedOptions: any = [];
  cuentasSelectedOptions: any = [];
  proveedoresSelectedOptions: any = [];
  //para recordar el tipo de movimiento original
  //movimientosObraSelectedTipoMovimiento: any = null;
  movimientosObraSelectedImporte: any = null;
  // tipo de servicio: CFDI de nota de crédito (E) o CFDI de complemento de pago
  tipoServicioModel = { key: "", name: "", default: 0 };
  tipoServicioOptions: any = [];
  loadingConceptosIngresos = false;
  //tipo de factura se carga en servicio
  tipoFacturaModel = { id_sat_conceptos_notas: 0, codigo: '0', descripcion: "" };
  tipoFacturaOptions: any = [];
  loadingTipoFactura = false;
  formaPagoSeleccionado: any = { sat_forma_pago_id: 0, id: "00", selected: false, activo: 0, codigo: "00", created_at: "2021-06-19 00:00:00", descripcion: "", text: "", updated_at: "2021-06-19 00:00:00" };
  formasPago: any = [];
  loadingFormasPago: boolean = false;
  //fechaPagoModel = moment(new Date()).format("DD/MM/YYYY");
  fechaPagoModel: any;
  fechaPagoElement: any;
  /* filters */
  obraFilter: any = {};
  obraFilterOptions: any[];
  cuentasFilter: any = [];
  cuentasFilterOptions: any[];
  cuentasFilterOptionsTraspasos: any[];
  conceptosFilter: any = [];
  conceptosFilterOptions: any[];
  proveedoresFilter: any = [];
  proveedoresFilterOptions: any[] = [];
  tipoProveedorFilter: any = {};
  tipoProveedorFilterOptions: any[];
  fechaInicialFilter: any;
  fechaFinalFilter: any;
  public tiposMovimientos: any[] = [];
  public tipoMovimientoFilter: any = null;

  /* ingreso interno */
  ingresoInterno: boolean = false;

  /* egreso interno a sobre (OYV Bancrea) */
  cuentasSobreTodas: any[] = [];

  isNew: any = false;
  page: number = 1;
  pageSize: number = 10;
  pageAll: number = 100;

  //mostrar dato
  tipoMov: any;

  private passwordActived: any;

  constructor(private movimientosObraService: MovimientosObraService,
    private obrasService: ObrasService,
    private cuentasService: CuentasService,
    private conceptosService: ConceptosService,
    private proveedoresService: ProveedoresService,
    private validatorService: ValidatorService,
    private helperService: HelpersService,
    private authService: AutenticacionService,
    private satService: CatalogosSatService,
    private globals: Globals) {
    // se colocó esto para que el this dentro de delete sea el del scope global
    this.getFechaActual();
    this.getFilters();
    this.resetMovimientosObraSelected = this.resetMovimientosObraSelected.bind(this);
    this.deleteMovimientoObra = this.deleteMovimientoObra.bind(this);
    this.updateMovimientosObraCheque = this.updateMovimientosObraCheque.bind(this);
    this.updateMovimientosObraCheque = this.updateMovimientosObraCheque.bind(this);

    this.passwordActived = globals.passwordActivate;
  }

  ngOnInit() {
    this.active();
  }

  pageChanged(event: any): void {
    if (event.page !== undefined)
      if (event.page != this.page) {
        this.page = event.page;
      }
    this.goPage(this.page);
  }

  active() {
    //console.log("this.passwordActived: ",this.passwordActived);
    if (this.passwordActived !== undefined)
      if (this.passwordActived) {
        this.securityActived = true;
      }
      else {
        this.securityActived = false;
      }

    if (this.authService.auth_user.key === 1) {
      this.securityActived = true;
    }
    else {
      this.securityActived = false;
    }
  }

  resetMovimientosObraSelected() {
    this.movimientosObraSelected = undefined;
    this.errors = {};
    this.agregarconceptos = false;
    if (this.movimientosObraSelected) {
      this.movimientosObraSelected.aplicaReembolso = false;
      this.movimientosObraSelected.porcentajeReembolso = '';
    }
  }

  startMovimientosObraSelected() {
    this.resetMovimientosObraSelected();
    this.movimientosObraSelected = this.movimientosObraService.getDefaultSchedule();
    this.movimientosObraSelected.fechaMovimiento = this.fechaActual;
    this.changeTipoMovimiento(this.movimientosObraSelected.tipoMovimiento);
  }

  /** Abre el modal para capturar un nuevo movimiento a Carpeta Blanca. */
  abrirNuevoMovCarpetaBlanca() {
    if (this.modalNuevoMovCB) {
      this.modalNuevoMovCB.open();
    }
  }

  /** Callback emitido por el modal al guardar exitosamente. */
  onMovimientoCarpetaBlancaGuardado(_body: any) {
    // No es necesario refrescar la tabla de movimientos de obra (los movimientos
    // de Carpeta Blanca viven en sobre_blanco_movimientos, tabla aparte).
    // Solo registramos para que el usuario sepa que se guardo y siga su flujo.
  }

  selectMovimientosObra(movimientosObra) {
    //changed this validation  because movimientosObra is null
    //if(movimientosObra !== undefined)
    if (movimientosObra) {
      this.resetMovimientosObraSelected();
      this.isNew = false;
      const movimientosObraCloned = JSON.parse(JSON.stringify(movimientosObra));
      this.movimientosObraSelected = movimientosObraCloned;
      this.changeObraSelected();
      console.log("this.movimientosObraSelected: ", this.movimientosObraSelected);
      if (this.movimientosObraSelected.conceptos.traspaso == 1) {
        this.changeTipoMovimiento(4, true); // forcing the validation
      } else {
        this.changeTipoMovimiento(this.movimientosObraSelected.tipoMovimiento, true); // forcing the validation
      }
    }
  }

  SelectedMovimientosObraClass(movimientosObra) {
    return (this.validatorService.required(this.movimientosObraSelected) &&
      this.movimientosObraSelected.folio == movimientosObra.folio &&
      this.movimientosObraSelected.idMovimientos == movimientosObra.idMovimientos) ? 'active' : '';
  }

  searchMovimientosObra(page = null) {
    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }
    if (this.searchText.length > 1) {
      this.getTotales();
      this.searchProcess = this.movimientosObraService.searchMovimientosObraWithFilters(this.searchText, this.getFiltersData(), page)
        .subscribe(response => {
          const content = response.json().content;
          this.movimientosObra = content.data;
          this.searchProcess = false;
          this.startPaginate(content);
          this.alterTable = (this.movimientosObra.length > 0) ? false : 'not_found';
        });
    } else {
      this.getMovimientosObra(1);
    }
  }

  getFechaActual() {
    this.movimientosObraService.getFechaActual()
      .subscribe((response) => {
        const content = response.json().content;
        this.fechaActual = content.fecha;
        this.fechaInicialFilter = this.helperService.substract_days(content.fecha, 30);
        this.fechaFinalFilter = content.fecha;
        this.getMovimientosObra(); // se inicia la carga del listado general
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);

        if (error == 400) {
          console.log('getFechasActual - error 400 ', error);
        }
      });
  }

  getTotales() {
    this.movimientosObraService.getTotales(this.getFiltersData())
      .subscribe((response) => {
        const respuesta = response.json();
        this.totales = respuesta.content;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);

        if (error == 400) {
          console.log('getTotales - error 400 ', error);
        }
      });
  }

  getMovimientosObra(page = null) {
    console.log("Obteniendo movimientos obra");
    console.log("La pagina es: ", page);
    this.getTotales();
    this.searchProcess = this.movimientosObraService.getMovimientosObraWithFilters(this.getFiltersData(), page)
      .subscribe(response => {
        const content = response.json().content;
        this.movimientosObra = content.data;
        //console.log("this.movimientosObra: ",this.movimientosObra);
        this.startPaginate(content);
        this.searchProcess = false;
        this.alterTable = (this.movimientosObra.length > 0) ? false : 'not_result';
        if (this.movimientosObra.length > 0) {
          this.selectMovimientosObra(this.movimientosObraSelected);
        }
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);

        if (error == 400) {
          console.log('getMovimientosObra - error 400 ', error);
        }
      });
  }
  createMovimientosObra() {
    this.errors = [];
    this.errors = this.movimientosObraService.validateMovimientosObra(this.movimientosObraSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }

    //Con el switch prendido pero sin cuenta interna, el movimiento se guardaba como un ingreso
    //sencillo y no se generaban el egreso sin IVA ni el ingreso al sobre, sin avisar nada.
    //Pasa si la ventana se cierra con ESC o dando clic fuera, que no apagan el switch.
    //Pago que cubre varias facturas: se manda la lista con lo aplicado a cada una y el servidor
    //timbra un solo complemento de pago con todas relacionadas
    if (this.cuentasPorCobrarSeleccionadas.length > 1) {
      if (this.avisoAgrupado) {
        this.errorModal.open({ 'title': 'Revisa los importes', 'description': this.avisoAgrupado });
        return false;
      }

      this.movimientosObraSelected.cuentas_por_cobrar = this.cuentasPorCobrarSeleccionadas.map(c => {
        return { id_cuenta_por_cobrar: c.id_cuenta_por_cobrar, importe: c.importe_aplicado };
      });
    } else {
      this.movimientosObraSelected.cuentas_por_cobrar = null;
    }

    if (!this.ingresoInternoCompleto()) {
      this.errorModal.open({
        'title': 'Falta el ingreso interno',
        'description': 'Prendiste "Aplica Ingreso interno?" pero no quedó seleccionada la obra y la cuenta. '
          + 'Vuelve a prender el switch para elegirlas, o apágalo si este movimiento no lleva ingreso interno.'
      });
      return false;
    }

    this.processing = true;
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    if (this.movimientosObraSelected.conceptosEgreso.idConceptos !== null && this.movimientosObraSelected.conceptosEgreso.idConceptos !== null) {
      this.movimientosObraSelected.idConceptosEgreso = this.movimientosObraSelected.conceptosEgreso.idConceptos;
    }
    this.movimientosObraSelected.idObras = this.movimientosObraSelected.obras.idObras;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado) ? 1 : 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado) ? 1 : 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia) ? 1 : 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi) ? 1 : 0;
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.idCuentasDestino = this.movimientosObraSelected.cuenta_destino.idCuentas;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)) {

      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)) {
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.tipoMovimiento = 4;
      // cuando es un traspaso, no se captura en front un proveedor, sin embargo
      // se espera en el reporte RESUMEN DE OBRA que los traspasos tengan
      // el proveedor TRASPASOS, que es el id 3225.
      // sin este fix, los movimientos de traspasos no son sumados en la
      // sección "traspasos" del resumen de obra
      this.movimientosObraSelected.idProveedores = 3225;
    }
    //Formato de nota de crédito y comprobante de pago
    // por ahora solo se realizará comprobante de pago
    if (this.movimientosObraSelected.id_facturas_cuentas != null && this.tipoServicioModel["key"] != "" &&
      this.movimientosObraSelected.metodo_pago == "PPD") {
      this.movimientosObraSelected["tipo_comprobante"] = this.tipoServicioModel["key"];
      this.movimientosObraSelected["forma_pago"] = this.formaPagoSeleccionado["codigo"];
      //console.log("this.fechaPagoModel: ",this.fechaPagoModel);
      this.movimientosObraSelected["fecha_comprobante"] = this.fechaPagoModel;
      if (this.tipoServicioModel.key == "E") {
        this.movimientosObraSelected["tipo_factura"] = this.tipoFacturaModel["codigo"];
      }
    }
    if (this.agregarconceptos) {
      this.movimientosObraSelected["todos_conceptos"] = "1";
    } else {
      this.movimientosObraSelected["todos_conceptos"] = "0";
    }
    this.movimientosObraSelected.es_sobre_blanco = this.movimientosObraSelected.es_sobre_blanco ? 1 : 0;
    console.log("JSON this.movimientosObraSelected: ", this.movimientosObraSelected);
    console.log("DEBUG_EGRESO_REEMBOLSO: ingresoInternoObj=", this.movimientosObraSelected.ingresoInternoObj, "aplicaReembolso=", this.movimientosObraSelected.aplicaReembolso, "porcentajeReembolso=", this.movimientosObraSelected.porcentajeReembolso);

    this.movimientosObraService.createMovimientosObra(this.movimientosObraSelected)
      .subscribe(response => {
        const respuesta = response.json();
        console.log("createMovimientosObra respuesta: ", respuesta);
        this.processing = false;
        if (respuesta.success) {
          this.successModal.open({
            'title': '¡Éxito!',
            'description': 'Se ha creado correctamente el movimiento de obra'
          });
          this.movimientosObraSelected.folio = respuesta.content.folio;
          this.movimientosObraSelected.idMovimientos = respuesta.content.id;
          this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
          this.movimientosObraSelected.importeLabel = respuesta.content.importeLabel;
          this.goPage(1);
          this.isNew = true;
          //added reset of form
          this.resetMovimientosObraSelected();
        }
      }, error => {
        // se revisan errores 403 - 500
        this.processing = false;
        this.helperService.httpGlobalError(error, false);
        //Maneja los errores de validación reportados por el servicio
        this.manejarErroresAlGuardarMovimiento(error);
      });

  }

  updateMovimientosObra() {
    this.errors = [];
    console.log(this.movimientosObraSelected);
    this.errors = this.movimientosObraService.validateMovimientosObra(this.movimientosObraSelected);
    if (!$.isEmptyObject(this.errors)) {
      return false;
    }
    this.processing = true;
    this.alterTable = 'starting';
    this.movimientosObraSelected.idCuentas = this.movimientosObraSelected.cuentas.idCuentas;
    this.movimientosObraSelected.idConceptos = this.movimientosObraSelected.conceptos.idConceptos;
    this.movimientosObraSelected.idObras = this.movimientosObraSelected.obras.idObras;
    this.movimientosObraSelected.numero = this.movimientosObraSelected.numero.toString();
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado) ? 1 : 0;
    this.movimientosObraSelected.chequeConciliado = (this.movimientosObraSelected.chequeConciliado) ? 1 : 0;
    this.movimientosObraSelected.chequeTransferencia = (this.movimientosObraSelected.chequeTransferencia) ? 1 : 0;
    this.movimientosObraSelected.enviadoCfdi = (this.movimientosObraSelected.enviadoCfdi) ? 1 : 0;
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.idCuentasDestino = this.movimientosObraSelected.cuenta_destino.idCuentas;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idInversionistas)) {
      this.movimientosObraSelected.idInversionistas = this.movimientosObraSelected.proveedores.idInversionistas;
      this.movimientosObraSelected.idProveedores = null;
    } else if (this.movimientosObraSelected.conceptos.traspaso != 1 && this.validatorService.required(this.movimientosObraSelected.proveedores.idProveedores)) {
      this.movimientosObraSelected.idProveedores = this.movimientosObraSelected.proveedores.idProveedores;
      this.movimientosObraSelected.idInversionistas = null;
    }
    if (this.movimientosObraSelected.conceptos.traspaso == 1) {
      this.movimientosObraSelected.tipoMovimiento = 4;

      // cuando es un traspaso, no se captura en front un proveedor, sin embargo
      // se espera en el reporte RESUMEN DE OBRA que los traspasos tengan
      // el proveedor TRASPASOS, que es el id 3225.
      // sin este fix, los movimientos de traspasos no son sumados en la
      // sección "traspasos" del resumen de obra
      this.movimientosObraSelected.idProveedores = 3225;
    }
    //Formato de nota de crédito y comprobante de pago
    console.log("this.tipoServicioModel: ", this.tipoServicioModel);
    if (this.movimientosObraSelected.id_facturas_cuentas != null && this.tipoServicioModel["key"] != "" &&
      this.movimientosObraSelected.metodo_pago == "PPD") {
      console.log("We will save", this.tipoServicioModel);
      this.movimientosObraSelected["tipo_comprobante"] = this.tipoServicioModel["key"];
      this.movimientosObraSelected["forma_pago"] = this.formaPagoSeleccionado["codigo"];
      this.movimientosObraSelected["fecha_comprobante"] = this.fechaPagoModel;
      if (this.tipoServicioModel.key == "E") {
        this.movimientosObraSelected["tipo_factura"] = this.tipoFacturaModel["codigo"];
      }
    }
    this.movimientosObraSelected.es_sobre_blanco = this.movimientosObraSelected.es_sobre_blanco ? 1 : 0;
    console.log("JSON this.movimientosObraSelected: ", JSON.stringify(this.movimientosObraSelected));
    this.movimientosObraService.updateMovimientosObra(this.movimientosObraSelected, this.movimientosObraSelected.idMovimientos)
      .subscribe(response => {
        this.processing = false;
        const respuesta = response.json();
        console.log(" updateMovimientosObra respuesta: ", respuesta);
        /*
        content:
          folio: 58533
          id: 63490
          importeLabel: "100.00"
          importeLetras: "CIEN PESOS 00/100 M.N."
        */
        if (response.json().success) {
          this.helperService.notification('Movimiento de obra guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
          this.movimientosObraSelected.folio = respuesta.content.folio;
          this.movimientosObraSelected.idMovimientos = respuesta.content.id;
          this.movimientosObraSelected.importeLetras = respuesta.content.importeLetras;
          this.movimientosObraSelected.importeLabel = respuesta.content.importeLabel;
          this.isNew = false;
          this.goPage(this.currentPage);
          this.selectMovimientosObra(this.movimientosObraSelected);
          this.SelectedMovimientosObraClass(this.movimientosObraSelected);
          //added reset of form
          this.resetMovimientosObraSelected();
        }
      }, error => {
        console.log("error: ", error);
        this.processing = false;
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        //Maneja los errores de validación reportados por el servicio
        this.manejarErroresAlGuardarMovimiento(error);
      });

  }


  confirmConciliarCheque() {
    if (this.movimientosObraSelected.chequeConciliado == 1) {
      this.tipoMov = 0;
    } else {
      this.tipoMov = 1;
    }
    this.confirmModal.open({
      'color': 'success',
      'title': 'Conciliar cheque',
      'description': '¿Está seguro de conciliar el cheque?',
      'callback': this.updateMovimientosObraCheque,
      'callbackClose': this.goPage(this.currentPage),
    });
  }

  updateMovimientosObraCheque() {
    this.movimientosObraSelected.chequeConciliado = this.tipoMov;
    this.movimientosObraSelected.chequeCancelado = (this.movimientosObraSelected.chequeCancelado) ? 1 : 0;
    this.movimientosObraService.updateMovimientosObra(this.movimientosObraSelected, this.movimientosObraSelected.idMovimientos)
      .subscribe(response => {
        this.processing = false;
        if (response.json().success) {
          this.helperService.notification('Movimiento de obra guardado', 'Se guardaron correctamente los datos del movimiento de obra', 'success');
          this.goPage(this.currentPage);
        }
      }, error => {
        this.processing = false;

        // se resuelven errores 403 y 500
        this.helperService.httpGlobalError(error);

        if (error.status == 400) {
          this.setBackendErrors(error.json().content);
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      });
  }

  writePermission() {
    return this.movimientosObraService.writePermission();
  }

  canExport() {
    return this.movimientosObraService.canExport();
  }

  canSecurity() {
    return this.movimientosObraService.canSecurity();
  }

  hasCarpetaBlancaPermission(): boolean {
    return this.authService.hasPermission(34, false);
  }

  confirmDeleteMovimientoObra() {
    this.confirmModal.open({
      'color': 'danger',
      'title': 'Eliminar movimiento',
      'description': "¡ATENCIÓN! <br> Está a punto de eliminar el movimiento de obra.",
      'callback': this.deleteMovimientoObra
    });
  }

  deleteMovimientoObra() {
    this.processing = true;
    this.movimientosObraService.deleteMovimientoObra(this.movimientosObraSelected.folio)
      .subscribe(
        response => {
          const movimientosObraDeleted = JSON.parse(JSON.stringify(this.movimientosObraSelected));
          this.processing = false;
          this.successModal.open({
            'title': 'Movimiento eliminado',
            'description': 'El movimiento con datos: <br> Obra: ' + movimientosObraDeleted.obras.nombreObra + ' <br> Cuenta: ' + movimientosObraDeleted.cuentas.nombreCuenta + '<br> Ha sido eliminado.'
          });

          this.goPage(this.currentPage);
          this.resetMovimientosObraSelected();
        }, error => {
          this.processing = false;

          // se resuelve los errores 403 y 500, no se requiere notification
          this.helperService.httpGlobalError(error, false);

          if (error.status == 400 || error.status == 500) {
            this.errorModal.open({
              'title': 'Error',
              'description': 'Ha ocurrido un error al intentar eliminar el movimiento de obra, inténtelo más tarde'
            });
          }

        });
  }

  changeObraFilter($event) {
    this.obraFilter = $event;
    this.getCuentasFilters();
  }

  /**
   * Al elegir proveedores en el buscador, el selector de obra solo debe ofrecer
   * las obras donde esos proveedores tienen movimientos. Sin proveedores, se
   * muestran todas.
   */
  changeProveedoresFilter($event) {
    this.proveedoresFilter = $event;
    this.recargarObrasDelFiltro();
  }

  recargarObrasDelFiltro() {
    // Mismo formato que usa el filtro de movimientos: "0-123" proveedor, "1-45" grupo.
    let proveedores = '';
    (this.proveedoresFilter || []).forEach((p, i, arr) => {
      if (p['idProveedores'] !== undefined) {
        proveedores += '0-' + p.idProveedores;
      } else if (p['idInversionistas'] !== undefined) {
        proveedores += '1-' + p.idInversionistas;
      }
      if (arr.length - 1 !== i) {
        proveedores += ',';
      }
    });

    this.obrasService.getObratoSelect('/movimientos', proveedores)
      .subscribe((response) => {
        const obras = response.json().content;

        // Solo se acota la lista de opciones. NO se toca la obra ni la cuenta que
        // el usuario ya eligio: borrarselas al seleccionar un proveedor lo obligaba
        // a capturar el filtro de nuevo.
        if (obras && obras.length > 0) {
          this.obraFilterOptions = obras;
        }
      });
  }

  changeObraSelected() {
    //console.log("changeObraSelected:",this.movimientosObraSelected);
    if (this.movimientosObraSelected && this.movimientosObraSelected.obras.idObras) {
      // cuentasFilter
      this.cuentasSelectedOptions = [];
      this.cuentasService.getCuentasByObraToSelect(this.movimientosObraSelected.obras.idObras, '/movimientos')
        .subscribe((response) => {
          const cuentas = response.json().content || [];
          this.cuentasSelectedOptions = cuentas;
        });
      const proveedoresSelectedOptions = [];
      this.proveedoresSelectedOptions = [];
      this.proveedoresService.getProveedoresAndInversionistas(this.movimientosObraSelected.obras.idObras, '/movimientos')
        .subscribe((response) => {
          const respuesta = response.json();
          proveedoresSelectedOptions.push({
            'text': 'Proveedores',
            'children': respuesta.content.proveedores,
            'key': 'idProveedores',
            'label': 'nombre'
          });
          proveedoresSelectedOptions.push({
            'text': 'Inversionistas',
            'children': respuesta.content.inversionistas,
            'key': 'idInversionistas',
            'label': 'nombre'
          });
          this.proveedoresSelectedOptions = proveedoresSelectedOptions;
        }, error => {
          this.proveedoresSelectedOptions = proveedoresSelectedOptions;
        });
      //this.fechaPagoModel se debe asignar para poder editar
    }

  }

  changeTipoMovimiento(tipoMovimiento, force = false) {

    if (this.movimientosObraSelectedWithId() && !force) {
      return false;
    }

    if (tipoMovimiento == 4) {
      this.movimientosObraSelected.conceptos.traspaso = 1;
    } else {
      this.movimientosObraSelected.tipoMovimiento = tipoMovimiento;
      this.movimientosObraSelected.conceptos.traspaso = 0;
    }

    this.conceptosService.getConceptosByTipoMovimientoToSelect(tipoMovimiento, '/movimientos')
      .subscribe((response) => {
        this.conceptosSelectedOptions = response.json().content;
        console.log("this.conceptosSelectedOptions: ", this.conceptosSelectedOptions);
      });
  }

  changeConceptoSelected(conceptoSelected) {

    conceptoSelected.traspaso = (conceptoSelected.tipo == 4) ? 1 : 0;
    this.movimientosObraSelected.conceptos = conceptoSelected;
    this.movimientosObraSelected.conceptos = conceptoSelected;
  }

  changeCuentaSelected(cuentaSelected) {
    this.movimientosObraSelected.cuentas = cuentaSelected;
  }

  changeConceptoEgresoSelected(conceptoSelected) {

    conceptoSelected.traspaso = (conceptoSelected.tipo == 4) ? 1 : 0;
    this.movimientosObraSelected.conceptosEgreso = conceptoSelected;
    console.log(this.movimientosObraSelected);
  }

  isTipoMovimiento(tipoMovimiento, movimiento = null) {
    if (!this.validatorService.required(this.movimientosObraSelected) && !movimiento) {
      return false;
    }

    if (!movimiento) {
      movimiento = this.movimientosObraSelected;
    }

    if (tipoMovimiento == 4 && movimiento.conceptos.traspaso == 1) {
      return true;
    }
    if (tipoMovimiento == movimiento.tipoMovimiento && movimiento.conceptos.traspaso != 1) {
      return true;
    }
    return false;
  }

  validImprimirRecibo() {
    var valid = false;
    if (this.movimientosObraSelected.cuentas !== null) {
      valid = true;
    }
    return valid;
  }

  imprimirRecibo() {
    if (this.movimientosObraSelected.cuentas !== null) {
      this.printReciboModal.open();
    }

  }

  imprimirCheque() {
    this.printChequeModal.open();
  }

  setBackendErrors(errors: any[]) {
    let temp_errors = [];

    Object.keys(errors).forEach(function (key) {
      temp_errors[key] = errors[key][0];
    });

    this.errors = temp_errors;
  }

  movimientosObraSelectedWithId() {
    if (!this.movimientosObraSelected)
      return false;

    return (this.validatorService.required(this.movimientosObraSelected.idMovimientos));
  }

  cancelarMovimientosObraSelected() {
    this.confirmModal.open({
      'title': 'Cancelar Cambios',
      'description': '¿Está seguro que desea cancelar estos cambios?',
      'callback': this.resetMovimientosObraSelected
    });
  }


  getFilters() {
    //Filtros de tipos de movimientos
    this.tiposMovimientos = [
      { key: '2', label: 'Ingresos' },
      { key: '1', label: 'Egresos' },
      { key: '4', label: 'Traspaso' }];

    // obraFilter
    this.obrasService.getObratoSelect('/movimientos')
      .subscribe((response) => {
        this.obraFilterOptions = response.json().content;
      });

    this.getCuentasFilters();

    // conceptosFilter
    this.conceptosService.getConceptostoSelect('/movimientos')
      .subscribe((response) => {
        this.conceptosFilterOptions = response.json().content;
      });

    // proveedoresFilter
    const proveedoresFilterOptions = [];
    this.proveedoresService.getProveedoresAndInversionistas(null, '/movimientos')
      .subscribe((response) => {
        const respuesta = response.json();
        proveedoresFilterOptions.push({
          'text': 'Proveedores',
          'children': respuesta.content.proveedores,
          'key': 'idProveedores',
          'label': 'nombre'
        });
        proveedoresFilterOptions.push({
          'text': 'Inversionistas',
          'children': respuesta.content.inversionistas,
          'key': 'idInversionistas',
          'label': 'nombre'
        });
        this.proveedoresFilterOptions = proveedoresFilterOptions;
      }, error => {
        this.proveedoresFilterOptions = proveedoresFilterOptions;
      });

    // tipoProveedoresFilter
    this.proveedoresService.getTiposProveedortoSelect('/movimientos')
      .subscribe((response) => {
        this.tipoProveedorFilterOptions = response.json().content;
      });
  }

  getCuentasFilters() {
    this.cuentasFilter = [];

    if (this.obraFilter !== undefined && !$.isEmptyObject(this.obraFilter)) {

      this.cuentasService.getCuentasByObraToSelect(this.obraFilter.idObras, '/movimientos')
        .subscribe((response) => {
          this.cuentasFilterOptions = response.json().content;
        });
      // El destino del traspaso NO depende del filtro de obra del reporte: siempre
      // debe ofrecer todas las cuentas (incluye carpeta blanca / sobre cuando el
      // modo sobre esta activo). Se recarga aparte para no quedar desfasado.
      this.cuentasService.getCuentastoSelect('/movimientos')
        .subscribe((response) => {
          this.cuentasFilterOptionsTraspasos = response.json().content;
        });
    } else {
      this.cuentasService.getCuentastoSelect('/movimientos')
        .subscribe((response) => {
          this.cuentasFilterOptions = response.json().content;
          this.cuentasFilterOptionsTraspasos = response.json().content;
        });
    }
  }
  getTipoMovimiento(movimiento) {
    if (movimiento.conceptos.traspaso == 1) {
      return 'TRASPASO';
    }

    return (movimiento.tipoMovimiento == 2) ? 'INGRESO' : 'EGRESO';
  }

  getFiltersData() {
    return {
      'obraFilter': this.obraFilter,
      'cuentasFilter': this.cuentasFilter,
      'conceptosFilter': this.conceptosFilter,
      'proveedoresFilter': this.proveedoresFilter,
      'tipoProveedorFilter': this.tipoProveedorFilter,
      'fechaInicial': this.fechaInicialFilter,
      'fechaFinal': this.fechaFinalFilter,
      'tipoMovimiento': (this.tipoMovimientoFilter && this.tipoMovimientoFilter.key
        ? this.tipoMovimientoFilter.key : null)
    };
  }

  filter(page = null) {

    if (this.searchProcess) {
      this.searchProcess.unsubscribe();
    }

    if (this.searchText && this.searchText.length > 1) {
      this.searchMovimientosObra();
      return false;
    }

    this.getTotales();
    this.searchProcess = this.movimientosObraService.getMovimientosObraWithFilters(this.getFiltersData(), page)
      .subscribe(response => {
        const content = response.json().content;
        this.movimientosObra = content.data;
        this.searchProcess = false;
        this.startPaginate(content);

        this.alterTable = (this.movimientosObra.length > 0) ? false : 'not_found';
      });

  }

  hasFilter() {
    const hasFilter = (!$.isEmptyObject(this.obraFilter) ||
      this.validatorService.required(this.cuentasFilter) ||
      this.validatorService.required(this.conceptosFilter) ||
      this.validatorService.required(this.proveedoresFilter) ||
      !$.isEmptyObject(this.tipoProveedorFilter));
    return hasFilter;
  }

  exportCSV() {
    this.exportingCSV = true;
    this.movimientosObraService.exportCSV(this.getFiltersData())
      .subscribe((response) => {
        this.exportingCSV = false;
      }, (error) => {
        // se resuelven los errores 403 y 500
        this.helperService.httpGlobalError(error);
      });
  }

  // SEGURITY MODULE
  securityModule() {
    if (!this.securityActived) {
      this.securityModal.open();
    } else {
      this.authService.closeKey()
        .subscribe((response) => {
          const respuesta = response.json();
          if (respuesta.success) {
            this.securityActived = false;
            this.securityModal.push({
              'passwordActivated': false
            });
            this.goPage(1);
            this.changeObraSelected();
            this.getCuentasFilters();
            this.resetMovimientosObraSelected();
          }
        });
    }

  }

  checkSecurityKey(password) {
    this.securityModal.loading = true;
    this.movimientosObraService.activeSecurityModule(password)
      .subscribe((response) => {
        const respuesta = response.json();
        this.securityModal.loading = false;
        if (respuesta.success === true) {
          this.goPage(1);
          this.changeObraSelected();
          this.getCuentasFilters();
          this.securityModal.push({
            'passwordActivated': true
          });
          this.securityModal.close();
          this.securityActived = true;
          this.resetMovimientosObraSelected();
          return this.securityActived;
        }
      }, (error) => {
        this.securityModal.loading = false;
        this.helperService.httpGlobalError(error, false);
        this.securityModal.lock();
        this.securityActived = false;
        this.securityModal.push({
          'passwordActivated': false
        });
      })
  }

  isTraspasoIngreso(movimientoObra) {

    if (!movimientoObra.conceptos) {
      return false;
    }
    const isTraspasoIngreso = (movimientoObra.conceptos.traspaso == 1 && movimientoObra.tipoMovimiento == 2) ? true : false;
    return isTraspasoIngreso;
  }

  // MODAL FUNCTIONS

  modalCallback(callback) {
    callback();
  }

  // MAIN SECTIONS FUNCTIONS

  mainContainerClass() {
    return (this.mostrarListado) ? "col-12" : "offset-2 col-8";
  }

  mainTableClass() {
    return (this.mostrarListado) ? "col-8" : "col-4";
  }

  mainDetailsClass() {
    return (this.mostrarListado) ? "col-4" : "col-8";
  }

  startPaginate(content) {
    this.paginate.first_item = content.from;
    this.paginate.last_item = content.to;
    this.paginate.last_page = content.last_page;
    this.paginate.per_page = content.per_page;
    this.paginate.total_items = content.total;
    this.paginate.current_page = content.current_page;
    this.currentPage = content.current_page;
    this.lastPage = content.last_page;

    this.paginate.pages = [];
    for (let i = 1; i <= this.paginate.last_page; i++) {
      this.paginate.pages.push({
        'number': i,
        'label': i
      });
    }
    this.pageAll = content.total;
    this.pageSize = content.per_page;
  }

  goPreviousPage() {
    this.goPage(this.paginate.current_page - 1);
  }

  goNextPage() {
    this.goPage(this.paginate.current_page + 1);
  }

  goPage(page) {
    if (this.searchText) {
      this.searchMovimientosObra(page);
    } else {
      this.getMovimientosObra(page);
    }
  }

  changeSwitchListado() {
    if (!this.mostrarListado) {
      this.movimientosObraSelected = this.movimientosObraService.getDefaultSchedule();
    }
  }

  validEditAndDeleteMovimiento() {
    var valid = true;
    if ((this.movimientosObraSelected.idCuentasDestino !== null && (this.movimientosObraSelected.cuentas === null || this.movimientosObraSelected.cuenta_destino === null)) && this.isNew == false) {
      valid = false
    }
    return valid;
  }

  showPrintModal() {
    var data = {
      searchText: this.searchText,
      filterData: this.getFiltersData(),
      obraFilterOptions: this.obraFilterOptions,
      cuentasFilterOptions: this.cuentasFilterOptions,
      conceptosFilterOptions: this.conceptosFilterOptions,
      proveedoresFilterOptions: this.proveedoresFilterOptions,
    };
    var isProyecciones = false;
    this.movimientosModal.open(data, isProyecciones);
  }

  copiarImporteAPresupuesto() {
    this.movimientosObraSelected.presupuesto = this.movimientosObraSelected.importe;
  }

  /**
   * CXC funcitons
   */
  public showModalCXC() {
    this.modalSeleccionarCXC.openModal(this.movimientosObraSelected.obras.idObras);
  }

  isoToMX(dateString) {
    const year = dateString.slice(0, 4);
    const month = dateString.slice(5, 7);
    const day = dateString.slice(8, 10);

    return day + '/' + month + '/' + year;
  }

  /**
   * Un deposito que cubre varias facturas. Se guardan los cargos elegidos con el importe que se
   * le aplica a cada uno (por default lo que deben) y el importe del movimiento es la suma.
   * Al guardar, el servidor timbra un solo complemento de pago con todas relacionadas.
   */
  public onSelectVariasCuentas(cuentas) {
    this.cuentasPorCobrarSeleccionadas = (cuentas || []).map(c => {
      c.importe_aplicado = parseFloat(c.total_por_cobrar) || 0;
      return c;
    });

    const primera = this.cuentasPorCobrarSeleccionadas[0];

    if (!primera) {
      return;
    }

    //El cliente y la forma de facturar salen de las facturas elegidas, igual que al cobrar una sola
    this.seleccionarProveedor(primera.id_proveedor);
    this.movimientosObraSelected.metodo_pago = primera.metodo_pago;
    this.movimientosObraSelected.id_cuenta_por_cobrar = primera.id_cuenta_por_cobrar;
    //Con esto la pantalla pide el tipo de comprobante, la forma y la fecha de pago, igual que
    //cuando se cobra una sola factura
    this.movimientosObraSelected.id_facturas_cuentas = primera.id_facturas_cuentas;
    this.movimientosObraSelected.descripcion = 'Pago que cubre ' + this.cuentasPorCobrarSeleccionadas.length + ' facturas';
    this.fechaPagoModel = primera.fecha_factura;

    if (primera.id_concepto) {
      this.seleccionarConcepto(primera.id_concepto);
    }

    //Carga el tipo de comprobante y, encadenado, las formas de pago. Sin esto el combo de
    //"Forma de pago" sale vacio ("No existen registros") y no se puede guardar, porque es
    //de donde salen tipo_comprobante, forma_pago y fecha_comprobante para el CFDI.
    this.getConceptosIngresos();

    this.recalcularImporteAgrupado();
  }

  public recalcularImporteAgrupado() {
    const total = this.totalAgrupado();
    this.movimientosObraSelected.importe = total;
    this.importeCuentaSeleccionada = total;
    this.avisoAgrupado = null;

    this.cuentasPorCobrarSeleccionadas.forEach(c => {
      if ((parseFloat(c.importe_aplicado) || 0) > (parseFloat(c.total_por_cobrar) || 0)) {
        this.avisoAgrupado = 'A la factura ' + (c.facturas_folio_number || c.id_cuenta_por_cobrar)
          + ' se le esta aplicando mas de lo que debe.';
      }
    });
  }

  public totalAgrupado(): number {
    let total = 0;

    this.cuentasPorCobrarSeleccionadas.forEach(c => {
      total += parseFloat(c.importe_aplicado) || 0;
    });

    return Math.round(total * 100) / 100;
  }

  public quitarCuentaAgrupada(indice) {
    this.cuentasPorCobrarSeleccionadas.splice(indice, 1);

    if (this.cuentasPorCobrarSeleccionadas.length < 2) {
      this.quitarCuentasAgrupadas();
      return;
    }

    this.recalcularImporteAgrupado();
  }

  public quitarCuentasAgrupadas() {
    this.cuentasPorCobrarSeleccionadas = [];
    this.avisoAgrupado = null;
    this.movimientosObraSelected.cuentas_por_cobrar = null;
    this.movimientosObraSelected.id_cuenta_por_cobrar = null;
  }

  public onSelectCuenta(cuenta_por_cobrar) {
    //Al elegir una sola factura se deja de ser un pago agrupado
    this.cuentasPorCobrarSeleccionadas = [];
    this.avisoAgrupado = null;
    this.movimientosObraSelected.cuentas_por_cobrar = null;
    console.log('#cuenta_por_cobrar', cuenta_por_cobrar);
    this.movimientosObraSelected.importe = cuenta_por_cobrar.total_por_cobrar;
    this.importeCuentaSeleccionada = cuenta_por_cobrar.total_por_cobrar;
    this.movimientosObraSelected.descripcion = cuenta_por_cobrar.concepto;
    this.movimientosObraSelected.facturas_total_conceptos = cuenta_por_cobrar.facturas_total_conceptos;
    console.log("Total de conceptos: ", this.movimientosObraSelected.facturas_total_conceptos);
    this.movimientosObraSelected.facturas_conceptos = cuenta_por_cobrar.facturas_conceptos;
    this.seleccionarProveedor(cuenta_por_cobrar.id_proveedor);

    //Las ventas no tienen asociado un concepto, en este caso no se puede seleccionar
    if (cuenta_por_cobrar.id_concepto) {
      this.seleccionarConcepto(cuenta_por_cobrar.id_concepto);
    }
    this.movimientosObraSelected.id_cuenta_por_cobrar = cuenta_por_cobrar.id_cuenta_por_cobrar;
    //console.log("cuenta_por_cobrar.id_facturas_cuentas: ",cuenta_por_cobrar.id_facturas_cuentas)
    //console.log(cuenta_por_cobrar.id_facturas_cuentas != null)
    this.movimientosObraSelected.metodo_pago = cuenta_por_cobrar.metodo_pago;
    if (cuenta_por_cobrar.id_facturas_cuentas != null && cuenta_por_cobrar.metodo_pago == "PPD") {
      console.log("cuenta_por_cobrar has id_facturas_cuentas: ", cuenta_por_cobrar);
      this.movimientosObraSelected.id_facturas_cuentas = cuenta_por_cobrar.id_facturas_cuentas;
      //Se propone la fecha de la factura, pero se puede cambiar por la fecha real en
      //que entro el dinero, aunque sea anterior (confirmado con el contador del cliente).
      this.fechaPagoModel = cuenta_por_cobrar.fecha_factura;
      //debemos esperar a que el calendario haga render para poder ajustar su minDate, revisar si se puede manejar con un tipo de promise
      //this.movimientosObraSelectedTipoMovimiento = this.movimientosObraSelected.tipoMovimiento;
      this.movimientosObraSelectedImporte = this.movimientosObraSelected.importe;
      console.log("this.movimientosObraSelected: ", this.movimientosObraSelected);
      //setTimeout( () => {
      //  $('#fechaPago').daterangepicker({
      //    singleDatePicker: true,
      //    showDropdowns: true,
      //    minDate: this.isoToMX(this.fechaPagoModel),
      //    locale: {
      //      format: 'DD/MM/YYYY'
      //    }
      //  });
      //}, 500);
      this.getConceptosIngresos();
    } else if (cuenta_por_cobrar.id_facturas_cuentas != null) {
      this.cargarFormasPago();
    }
  }

  public sumarImporte(activo?: boolean) {
    //Al apagar el switch se regresa al importe de la cuenta seleccionada
    if (activo === false) {
      this.movimientosObraSelected.importe = this.importeCuentaSeleccionada;
      return;
    }
    let total = 0;
    console.log("this.movimientosObraSelected.facturas_conceptos: ", this.movimientosObraSelected.facturas_conceptos);
    for (let factura of this.movimientosObraSelected.facturas_conceptos) {
      console.log("factura.price: ", factura.price);
      total += parseFloat(factura.price)
    }
    console.log("total: ", total);
    this.movimientosObraSelected.importe = total;
  }

  /**
   * CXP funcitons
   */
  public showModalCXP() {
    this.modalSeleccionCXP.openModal();
  }

  public cxpSeleccionada(cuentaPorPagar) {
    //Selecciona los items del formulario de captura de un movimiento
    this.movimientosObraSelected.importe = cuentaPorPagar.importe_pendiente_pago;
    this.movimientosObraSelected.descripcion = cuentaPorPagar.gasto_descripcion;
    this.seleccionarProveedor(cuentaPorPagar.id_proveedor);
    this.seleccionarConcepto(cuentaPorPagar.id_concepto);
    this.movimientosObraSelected.id_cuenta_por_pagar = cuentaPorPagar.id_cuenta_por_pagar;
  }

  private seleccionarProveedor(id_proveedor) {
    //Este cast es necesario, ya que en producción el servicio retorna el id_proveedor como string
    id_proveedor = Number(id_proveedor);
    let component = this;
    let proveedores = this.proveedoresSelectedOptions[0].children;
    proveedores.some(proveedor => {
      if (proveedor.idProveedores === id_proveedor) {
        component.movimientosObraSelected.proveedores = proveedor;
        //console.log("proveedor: ",proveedor);
        return true;
      }
    });
  }

  private seleccionarConcepto(id_concepto) {
    //Este cast es necesario, ya que en producción el servicio retorna el id_concepto como string
    id_concepto = Number(id_concepto);
    let component = this;
    let conceptos = this.conceptosSelectedOptions
    conceptos.some(concepto => {
      if (concepto.idConceptos === id_concepto) {
        component.movimientosObraSelected.conceptos = concepto;
        return true;
      }
    });
  }

  private manejarErroresAlGuardarMovimiento(errorResponse) {
    if (errorResponse.status == 400) {
      const result = errorResponse.json().content;
      if (result && result.importe) {
        let errors = [];
        errors["importe"] = result.importe[0];
        this.errors = errors;
      } else {
        //alert("ERROR: "+JSON.stringify(errorResponse));
        this.helperService.httpGlobalError(errorResponse);
        console.log("ERROR: ", errorResponse);
      }
      //se manejan errores default 400 en helper
      //else{
      //  alert("ERROR: "+JSON.stringify(errorResponse));
      //  console.log("ERROR: ",errorResponse);
      //}
    }
  }

  /**
   * Escucha el evento de selección en select de tipo de servicio
   */
  seleccionarTipoServicio(event) {
    this.tipoServicioModel = event;
    if (this.tipoServicioModel.key == "E") { //selección de nota de crédito
      this.getTipoFactura();
      this.movimientosObraSelected.importe = this.movimientosObraSelectedImporte;
      //este cambio no se hará en front
      //this.movimientosObraSelected.tipoMovimiento = 1;
    }/*else{
      //regresamos el tipo de movimiento al que tenía originalmente
      this.movimientosObraSelected.tipoMovimiento = this.movimientosObraSelectedTipoMovimiento;
    }*/
  }

  /**
   * Obtiene el catálogo de tipo de servicio: comprobante de pago o nota de crédito
   */
  getConceptosIngresos() {
    this.loadingConceptosIngresos = true;
    this.satService.getSatConceptosIngresos()
      .subscribe(response => {
        const content = response.json().content;
        console.log("getConceptosIngresos content: ", content);
        this.tipoServicioOptions = content;
        this.tipoServicioModel = this.tipoServicioOptions.find(val => Number(val["default"] == 1));
        this.loadingConceptosIngresos = false;
        this.cargarFormasPago();
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
        if (error == 400) {
          console.log('getConceptosIngresos - error 400 ', error);
        }
        this.loadingConceptosIngresos = false;
      });
  }

  /**
   * Obtiene el catálogo de notas de crédito.
   */
  getTipoFactura() {
    this.loadingTipoFactura = true;
    this.satService.getSatConceptosNotas()
      .subscribe(response => {
        const content = response.json().content;
        console.log("getTipoFactura content: ", content);
        this.tipoFacturaOptions = content;
        this.tipoFacturaModel = this.tipoFacturaOptions.find(val => Number(val["default"] == 1));
        this.loadingTipoFactura = false;
      }, (error) => {
        // se revisan errores 403 - 500
        this.helperService.httpGlobalError(error);
        if (error == 400) {
          console.log('getTipoFactura - error 400 ', error);
        }
        this.loadingTipoFactura = false;
      });
  }

  cargarFormasPago() {
    this.loadingFormasPago = true;
    this.satService.obtenerFormasPago()
      .subscribe(
        (response) => {
          let formasPago = response.json().content;
          console.log("formasPago: ", formasPago);
          this.formasPago = formasPago;
          this.formaPagoSeleccionado = this.formasPago.find(val => Number(val["default"]) == 1);
          this.loadingFormasPago = false;
        },
        (error) => {
          this.loadingFormasPago = false;
          alert("ERROR:: " + JSON.stringify(error));
        }
      );
  }

  setFechaPagoModel(event) {
    console.log("setFechaPagoModel event: ", event);
    this.fechaPagoModel = event;
  }

  /**
   * Ingreso interno
   */
  public isObra(obra: string) {
    console.log("this.movimientosObraSelected.obras.nombreObra: ", this.movimientosObraSelected.obras.nombreObra);
    console.log("obra: ", obra);
    return this.movimientosObraSelected.obras.nombreObra === obra;
  }


  public showModalIngresoInterno() {
    this.movimientosObraSelected.ingresoInternoObj = null;
    this.modalIngresoInterno.openModal();
  }

  public cancelarModalIngresoInterno() {
    this.movimientosObraSelected.ingresoInterno = false;
  }


  public toggleReembolso() {
    console.log("Toggle Reembolso Triggered");
    if (!this.movimientosObraSelected.aplicaReembolso) {
      this.movimientosObraSelected.porcentajeReembolso = '';
    }
  }

  public onReembolsoChange(value: boolean) {
    this.movimientosObraSelected.aplicaReembolso = value;
    console.log("onReembolsoChange:", value);
    if (!value) {
      this.movimientosObraSelected.porcentajeReembolso = '';
    }
  }

  public asignarIngresoInterno(ingresoInterno) {
    this.movimientosObraSelected.ingresoInternoObj = ingresoInterno;
  }

  /** Con el switch prendido tiene que venir la obra y la cuenta elegidas en la ventana. */
  public ingresoInternoCompleto(): boolean {
    if (!this.movimientosObraSelected.ingresoInterno) {
      return true;
    }

    const obj = this.movimientosObraSelected.ingresoInternoObj;

    return !!(obj
      && obj.obraIngresoInterno && obj.obraIngresoInterno.idObras
      && obj.cuentaIngresoInterno && obj.cuentaIngresoInterno.idCuentas);
  }

  /**
   * Egreso interno a sobre: aplica solo en creacion para egresos de CONSTRUCTORA OYV en cuenta BANCREA.
   */
  public isCuentaBancrea(): boolean {
    if (!this.movimientosObraSelected || !this.movimientosObraSelected.cuentas) {
      return false;
    }
    const banco = this.movimientosObraSelected.cuentas.nombreBanco || this.movimientosObraSelected.cuentas.bancoCuenta || '';
    return banco.toUpperCase().indexOf('BANCREA') !== -1;
  }

  public cargarCuentasSobreTodas() {
    if (this.cuentasSobreTodas && this.cuentasSobreTodas.length > 0) {
      return;
    }
    this.cuentasService.getCuentasSobreTodas()
      .subscribe((response) => {
        const respuesta = response.json();
        this.cuentasSobreTodas = (respuesta && respuesta.content) ? respuesta.content : [];
      }, () => {
        this.cuentasSobreTodas = [];
      });
  }

  public onToggleEgresoInternoSobre(value: boolean) {
    if (!this.movimientosObraSelected) return;
    this.movimientosObraSelected.egresoInternoSobre = value;
    if (value) {
      this.cargarCuentasSobreTodas();
    } else {
      this.movimientosObraSelected.egresoInternoSobreObj = null;
      this.movimientosObraSelected.cuentaEgresoInternoSobre = null;
    }
  }

  public changeCuentaEgresoInternoSobre(cuenta) {
    if (!this.movimientosObraSelected) return;
    this.movimientosObraSelected.cuentaEgresoInternoSobre = cuenta;
    if (cuenta && cuenta.idCuentas) {
      this.movimientosObraSelected.egresoInternoSobreObj = { cuentaEgresoInternoSobre: cuenta };
    } else {
      this.movimientosObraSelected.egresoInternoSobreObj = null;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/components/movimientos-obra/movimientos-obra.component.ts